export enum VehicleDataType {
	BBOX = 'bbox',
	ORDER = 'order',
}
